export default "__VITE_ASSET__BDtCgdns__"